export type AppHeaderTokens = {
	background: string;
};

export default {
	background: '{primary.500}',
} satisfies AppHeaderTokens;
